import React, { useEffect, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'

import emotionWordsService from 'services/emotion-words'
import ExternalHtml from 'common/services/html-content/external-html'
import { AppState } from 'common/store/reducer'

import EmotionSection from './emotion-section'
import MoodSection from './mood-section'

const connector = connect(
  (state: AppState) => ({
    pleasantnessLevel: state.moodMeter.forms.plot.data.pleasantness,
    energyLevel: state.moodMeter.forms.plot.data.energy,
  }),
  {
    emotionWordsRequest: emotionWordsService.actions.request,
  },
)

type Props = ConnectedProps<typeof connector> & {
  withGroupId?: string
  submitMoodMeterPlot: (groupId?: string) => void
}

function PlotJourney({
  pleasantnessLevel,
  energyLevel,
  emotionWordsRequest,
  withGroupId,
  submitMoodMeterPlot,
}: Props) {
  const [initiated, setInitiated] = useState(false)

  useEffect(() => {
    // @ts-expect-error - service typing
    emotionWordsRequest({ urlParams: { onlyMoodMeter: true } })
  }, [emotionWordsRequest])

  useEffect(() => {
    if ((pleasantnessLevel !== 0 || energyLevel !== 0) && !initiated) {
      setInitiated(true) // eslint-disable-line react/no-did-update-set-state
    }
  }, [pleasantnessLevel, energyLevel, initiated, setInitiated])

  return (
    <div className="grid-container mm-map-results-container">
      <div className="grid-x grid-padding-x align-justify">
        <div className="small-12 medium-8 large-6 cell">
          <MoodSection />
        </div>
        <main className="main small-12 medium-4 large-5 cell" role="main">
          {initiated ? (
            <EmotionSection submitHandler={() => submitMoodMeterPlot(withGroupId)} />
          ) : (
            <div className="mm-v2-description">
              <h1>
                <ExternalHtml slug="mood-meter/self-plot/title" />
              </h1>
              <div>
                <ExternalHtml slug="mood-meter/self-plot/content" />
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  )
}

export default connector(PlotJourney)
